import React from "react";
import { colorsV2 } from "../styles/colors";

export default (props) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          border: "solid 1px grey",
          padding: 30,
          borderRadius: 10,
          margin: 30,
        }}
      >
        <h1 style={{ textAlign: "center", color: colorsV2.main }}>
          Already Submitted
        </h1>
        <p>
          We are sorry you may only submit one NPS Survey per user per year.
          You'll have an opportunity next year to tell us how we did!
        </p>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/layout/NPSSubmitted.js